import React from "react";
import { Tag } from "antd";
import moment from "moment";

// Members can still chat for a while after their program ends (api #100); the label tells the coach.
const ProgramEndedTag = ({ participant }) => {
  if (!participant?.program_ended) return null;

  return (
    <Tag
      color="orange"
      // moment(undefined) is today, so a missing end date gets no date at all.
      title={
        participant.program_end_date
          ? `Program ended on ${moment(participant.program_end_date).format("DD-MM-YYYY")}`
          : "Program ended"
      }
      style={{ marginInlineStart: 8 }}
    >
      Program ended
    </Tag>
  );
};

export default ProgramEndedTag;
